<template>
  <widget title="Off Today">
    <template v-slot:content>
      <v-row v-for="user in offToday.users" v-bind:key="user.loginId">
        <v-col cols="3" xl="3" md="2">{{ user.firstName+' '+user.lastName}}</v-col>
        <v-col cols="9" xl="9" md="9">{{ user.offFrom + ' - '+user.offTo }}</v-col>
      </v-row>
    </template>
  </widget>
</template>

<script>

import store from '@/store'
import Widget from './Widget'

export default {
  name: 'OffToday',
  components: {
    Widget
  },
  computed: {
    offToday () {
      return store.state.dashboard.offToday
    }
  },
  beforeMount () {
    store.dispatch('dashboard/fetchOffToday')
  }
}
</script>

<style scoped>

</style>
